import request from './request.js';

// 税局模板上传
export async function importTaxOfficeTemplate(params = {}) {
    return await request('dataAcquisition/file/upload', 'post', params)
}